import { EnvestnetYodleeLabel } from "@yodlee/common-components/dist/assets/logo";
import React from "react";
import { DevelopersBanner } from './../../assets/banner';

function LargeScreenOnly() {
    return (
        <div className='large-screen-only'>
            <img src={EnvestnetYodleeLabel} height="47px" width="107px" className='main-logo' alt='Yodlee-label' />
            <div className='large-screen-title'>Please switch to desktop.</div>
            <div className='large-screen-sub-title'>This experience is optimized for a larger screen size.</div>
            <img src={DevelopersBanner} width="100%" className='developer-banner' alt='developer' />
        </div>
    );
}

export default LargeScreenOnly;
